import { differenceBy } from 'lodash';

const allCountries = [
  {
    key: 'AF',
    name: 'Afghanistan',
  },
  {
    key: 'AL',
    name: 'Albania',
  },
  {
    key: 'DZ',
    name: 'Algeria',
  },
  {
    key: 'AS',
    name: 'American Samoa',
  },
  {
    key: 'AD',
    name: 'Andorra',
  },
  {
    key: 'AO',
    name: 'Angola',
  },
  {
    key: 'AI',
    name: 'Anguilla',
  },
  {
    key: 'AQ',
    name: 'Antarctica',
  },
  {
    key: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    key: 'AR',
    name: 'Argentina',
  },
  {
    key: 'AM',
    name: 'Armenia',
  },
  {
    key: 'AW',
    name: 'Aruba',
  },
  {
    key: 'AU',
    name: 'Australia',
  },
  {
    key: 'AT',
    name: 'Austria',
  },
  {
    key: 'AZ',
    name: 'Azerbaijan',
  },
  {
    key: 'BS',
    name: 'Bahamas',
  },
  {
    key: 'BH',
    name: 'Bahrain',
  },
  {
    key: 'BD',
    name: 'Bangladesh',
  },
  {
    key: 'BB',
    name: 'Barbados',
  },
  {
    key: 'BY',
    name: 'Belarus',
  },
  {
    isEu: true,
    key: 'BE',
    name: 'Belgium',
  },
  {
    key: 'BZ',
    name: 'Belize',
  },
  {
    key: 'BJ',
    name: 'Benin',
  },
  {
    key: 'BM',
    name: 'Bermuda',
  },
  {
    key: 'BT',
    name: 'Bhutan',
  },
  {
    key: 'BO',
    name: 'Bolivia, Plurinational State of',
  },
  {
    key: 'BQ',
    name: 'Bonaire, Sint Eustatius and Saba',
  },
  {
    key: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    key: 'BW',
    name: 'Botswana',
  },
  {
    key: 'BV',
    name: 'Bouvet Island',
  },
  {
    key: 'BR',
    name: 'Brazil',
  },
  {
    key: 'IO',
    name: 'British Indian Ocean Territory',
  },
  {
    key: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    isEu: true,
    key: 'BG',
    name: 'Bulgaria',
  },
  {
    key: 'BF',
    name: 'Burkina Faso',
  },
  {
    key: 'BI',
    name: 'Burundi',
  },
  {
    key: 'CV',
    name: 'Cabo Verde',
  },
  {
    key: 'KH',
    name: 'Cambodia',
  },
  {
    key: 'CM',
    name: 'Cameroon',
  },
  {
    key: 'CA',
    name: 'Canada',
  },
  {
    key: 'KY',
    name: 'Cayman Islands',
  },
  {
    key: 'CF',
    name: 'Central African Republic',
  },
  {
    key: 'TD',
    name: 'Chad',
  },
  {
    key: 'CL',
    name: 'Chile',
  },
  {
    key: 'CN',
    name: 'China',
  },
  {
    key: 'CX',
    name: 'Christmas Island',
  },
  {
    key: 'CC',
    name: 'Cocos (Keeling) Islands',
  },
  {
    key: 'CO',
    name: 'Colombia',
  },
  {
    key: 'KM',
    name: 'Comoros',
  },
  {
    key: 'CG',
    name: 'Congo',
  },
  {
    key: 'CD',
    name: 'Congo, the Democratic Republic of the',
  },
  {
    key: 'CI',
    name: "Côte d'Ivoire",
  },
  {
    key: 'CK',
    name: 'Cook Islands',
  },
  {
    key: 'CR',
    name: 'Costa Rica',
  },
  {
    isEu: true,
    key: 'HR',
    name: 'Croatia',
  },
  {
    key: 'CU',
    name: 'Cuba',
  },
  {
    key: 'CW',
    name: 'Curaçao',
  },
  {
    isEu: true,
    key: 'CY',
    name: 'Cyprus',
  },
  {
    isEu: true,
    key: 'CZ',
    name: 'Czech Republic',
  },
  {
    isEu: true,
    key: 'DK',
    name: 'Denmark',
  },
  {
    key: 'DJ',
    name: 'Djibouti',
  },
  {
    key: 'DM',
    name: 'Dominica',
  },
  {
    key: 'DO',
    name: 'Dominican Republic',
  },
  {
    key: 'EC',
    name: 'Ecuador',
  },
  {
    key: 'EG',
    name: 'Egypt',
  },
  {
    key: 'SV',
    name: 'El Salvador',
  },
  {
    key: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    key: 'ER',
    name: 'Eritrea',
  },
  {
    isEu: true,
    key: 'EE',
    name: 'Estonia',
  },
  {
    key: 'ET',
    name: 'Ethiopia',
  },
  {
    key: 'FK',
    name: 'Falkland Islands (Malvinas)',
  },
  {
    key: 'FO',
    name: 'Faroe Islands',
  },
  {
    key: 'FJ',
    name: 'Fiji',
  },
  {
    isEu: true,
    key: 'FI',
    name: 'Finland',
  },
  {
    isEu: true,
    key: 'FR',
    name: 'France',
  },
  {
    key: 'GF',
    name: 'French Guiana',
  },
  {
    key: 'PF',
    name: 'French Polynesia',
  },
  {
    key: 'TF',
    name: 'French Southern Territories',
  },
  {
    key: 'GA',
    name: 'Gabon',
  },
  {
    key: 'GM',
    name: 'Gambia',
  },
  {
    key: 'GE',
    name: 'Georgia',
  },
  {
    isEu: true,
    key: 'DE',
    name: 'Germany',
  },
  {
    key: 'GH',
    name: 'Ghana',
  },
  {
    key: 'GI',
    name: 'Gibraltar',
  },
  {
    isEu: true,
    key: 'GR',
    name: 'Greece',
    vatPrefix: 'EL',
  },
  {
    key: 'GL',
    name: 'Greenland',
  },
  {
    key: 'GD',
    name: 'Grenada',
  },
  {
    key: 'GP',
    name: 'Guadeloupe',
  },
  {
    key: 'GU',
    name: 'Guam',
  },
  {
    key: 'GT',
    name: 'Guatemala',
  },
  {
    key: 'GG',
    name: 'Guernsey',
  },
  {
    key: 'GN',
    name: 'Guinea',
  },
  {
    key: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    key: 'GY',
    name: 'Guyana',
  },
  {
    key: 'HT',
    name: 'Haiti',
  },
  {
    key: 'HM',
    name: 'Heard Island and McDonald Islands',
  },
  {
    key: 'VA',
    name: 'Holy See',
  },
  {
    key: 'HN',
    name: 'Honduras',
  },
  {
    key: 'HK',
    name: 'Hong Kong',
  },
  {
    isEu: true,
    key: 'HU',
    name: 'Hungary',
  },
  {
    key: 'IS',
    name: 'Iceland',
  },
  {
    key: 'IN',
    name: 'India',
  },
  {
    key: 'ID',
    name: 'Indonesia',
  },
  {
    key: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    key: 'IQ',
    name: 'Iraq',
  },
  {
    isEu: true,
    key: 'IE',
    name: 'Ireland',
  },
  {
    key: 'IM',
    name: 'Isle of Man',
  },
  {
    key: 'IL',
    name: 'Israel',
  },
  {
    isEu: true,
    key: 'IT',
    name: 'Italy',
  },
  {
    key: 'JM',
    name: 'Jamaica',
  },
  {
    key: 'JP',
    name: 'Japan',
  },
  {
    key: 'JE',
    name: 'Jersey',
  },
  {
    key: 'JO',
    name: 'Jordan',
  },
  {
    key: 'KZ',
    name: 'Kazakhstan',
  },
  {
    key: 'KE',
    name: 'Kenya',
  },
  {
    key: 'KI',
    name: 'Kiribati',
  },
  {
    key: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    key: 'KR',
    name: 'Korea, Republic of',
  },
  {
    key: 'KW',
    name: 'Kuwait',
  },
  {
    key: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    key: 'LA',
    name: "Lao People's Democratic Republic",
  },
  {
    isEu: true,
    key: 'LV',
    name: 'Latvia',
  },
  {
    key: 'LB',
    name: 'Lebanon',
  },
  {
    key: 'LS',
    name: 'Lesotho',
  },
  {
    key: 'LR',
    name: 'Liberia',
  },
  {
    key: 'LY',
    name: 'Libya',
  },
  {
    key: 'LI',
    name: 'Liechtenstein',
  },
  {
    isEu: true,
    key: 'LT',
    name: 'Lithuania',
  },
  {
    isEu: true,
    key: 'LU',
    name: 'Luxembourg',
  },
  {
    key: 'MO',
    name: 'Macao',
  },
  {
    key: 'MK',
    name: 'Macedonia, the former Yugoslav Republic of',
  },
  {
    key: 'MG',
    name: 'Madagascar',
  },
  {
    key: 'MW',
    name: 'Malawi',
  },
  {
    key: 'MY',
    name: 'Malaysia',
  },
  {
    key: 'MV',
    name: 'Maldives',
  },
  {
    key: 'ML',
    name: 'Mali',
  },
  {
    isEu: true,
    key: 'MT',
    name: 'Malta',
  },
  {
    key: 'MH',
    name: 'Marshall Islands',
  },
  {
    key: 'MQ',
    name: 'Martinique',
  },
  {
    key: 'MR',
    name: 'Mauritania',
  },
  {
    key: 'MU',
    name: 'Mauritius',
  },
  {
    key: 'YT',
    name: 'Mayotte',
  },
  {
    key: 'MX',
    name: 'Mexico',
  },
  {
    key: 'FM',
    name: 'Micronesia, Federated States of',
  },
  {
    key: 'MD',
    name: 'Moldova, Republic of',
  },
  {
    key: 'MC',
    name: 'Monaco',
  },
  {
    key: 'MN',
    name: 'Mongolia',
  },
  {
    key: 'ME',
    name: 'Montenegro',
  },
  {
    key: 'MS',
    name: 'Montserrat',
  },
  {
    key: 'MA',
    name: 'Morocco',
  },
  {
    key: 'MZ',
    name: 'Mozambique',
  },
  {
    key: 'MM',
    name: 'Myanmar',
  },
  {
    key: 'NA',
    name: 'Namibia',
  },
  {
    key: 'NR',
    name: 'Nauru',
  },
  {
    key: 'NP',
    name: 'Nepal',
  },
  {
    isEu: true,
    key: 'NL',
    name: 'Netherlands',
  },
  {
    key: 'NC',
    name: 'New Caledonia',
  },
  {
    key: 'NZ',
    name: 'New Zealand',
  },
  {
    key: 'NI',
    name: 'Nicaragua',
  },
  {
    key: 'NE',
    name: 'Niger',
  },
  {
    key: 'NG',
    name: 'Nigeria',
  },
  {
    key: 'NU',
    name: 'Niue',
  },
  {
    key: 'NF',
    name: 'Norfolk Island',
  },
  {
    key: 'MP',
    name: 'Northern Mariana Islands',
  },
  {
    key: 'NO',
    name: 'Norway',
  },
  {
    key: 'OM',
    name: 'Oman',
  },
  {
    key: 'PK',
    name: 'Pakistan',
  },
  {
    key: 'PW',
    name: 'Palau',
  },
  {
    key: 'PS',
    name: 'Palestine, State of',
  },
  {
    key: 'PA',
    name: 'Panama',
  },
  {
    key: 'PG',
    name: 'Papua New Guinea',
  },
  {
    key: 'PY',
    name: 'Paraguay',
  },
  {
    key: 'PE',
    name: 'Peru',
  },
  {
    key: 'PH',
    name: 'Philippines',
  },
  {
    key: 'PN',
    name: 'Pitcairn',
  },
  {
    isEu: true,
    key: 'PL',
    name: 'Poland',
  },
  {
    isEu: true,
    key: 'PT',
    name: 'Portugal',
  },
  {
    key: 'PR',
    name: 'Puerto Rico',
  },
  {
    key: 'QA',
    name: 'Qatar',
  },
  {
    isEu: true,
    key: 'RO',
    name: 'Romania',
  },
  {
    key: 'RU',
    name: 'Russian Federation',
  },
  {
    key: 'RW',
    name: 'Rwanda',
  },
  {
    key: 'RE',
    name: 'Réunion',
  },
  {
    key: 'BL',
    name: 'Saint Barthélemy',
  },
  {
    key: 'SH',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
  },
  {
    key: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    key: 'LC',
    name: 'Saint Lucia',
  },
  {
    key: 'MF',
    name: 'Saint Martin (French part)',
  },
  {
    key: 'PM',
    name: 'Saint Pierre and Miquelon',
  },
  {
    key: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    key: 'WS',
    name: 'Samoa',
  },
  {
    key: 'SM',
    name: 'San Marino',
  },
  {
    key: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    key: 'SA',
    name: 'Saudi Arabia',
  },
  {
    key: 'SN',
    name: 'Senegal',
  },
  {
    key: 'RS',
    name: 'Serbia',
  },
  {
    key: 'SC',
    name: 'Seychelles',
  },
  {
    key: 'SL',
    name: 'Sierra Leone',
  },
  {
    key: 'SG',
    name: 'Singapore',
  },
  {
    key: 'SX',
    name: 'Sint Maarten (Dutch part)',
  },
  {
    isEu: true,
    key: 'SK',
    name: 'Slovakia',
  },
  {
    isEu: true,
    key: 'SI',
    name: 'Slovenia',
  },
  {
    key: 'SB',
    name: 'Solomon Islands',
  },
  {
    key: 'SO',
    name: 'Somalia',
  },
  {
    key: 'ZA',
    name: 'South Africa',
  },
  {
    key: 'GS',
    name: 'South Georgia and the South Sandwich Islands',
  },
  {
    key: 'SS',
    name: 'South Sudan',
  },
  {
    isEu: true,
    key: 'ES',
    name: 'Spain',
  },
  {
    key: 'LK',
    name: 'Sri Lanka',
  },
  {
    key: 'SD',
    name: 'Sudan',
  },
  {
    key: 'SR',
    name: 'Suriname',
  },
  {
    key: 'SJ',
    name: 'Svalbard and Jan Mayen',
  },
  {
    key: 'SZ',
    name: 'Swaziland',
  },
  {
    isEu: true,
    key: 'SE',
    name: 'Sweden',
  },
  {
    key: 'CH',
    name: 'Switzerland',
  },
  {
    key: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    key: 'TW',
    name: 'Taiwan, Province of China',
  },
  {
    key: 'TJ',
    name: 'Tajikistan',
  },
  {
    key: 'TZ',
    name: 'Tanzania, United Republic of',
  },
  {
    key: 'TH',
    name: 'Thailand',
  },
  {
    key: 'TL',
    name: 'Timor-Leste',
  },
  {
    key: 'TG',
    name: 'Togo',
  },
  {
    key: 'TK',
    name: 'Tokelau',
  },
  {
    key: 'TO',
    name: 'Tonga',
  },
  {
    key: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    key: 'TN',
    name: 'Tunisia',
  },
  {
    key: 'TR',
    name: 'Turkey',
  },
  {
    key: 'TM',
    name: 'Turkmenistan',
  },
  {
    key: 'TC',
    name: 'Turks and Caicos Islands',
  },
  {
    key: 'TV',
    name: 'Tuvalu',
  },
  {
    key: 'UG',
    name: 'Uganda',
  },
  {
    key: 'UA',
    name: 'Ukraine',
  },
  {
    key: 'AE',
    name: 'United Arab Emirates',
  },
  {
    isEu: true,
    key: 'GB',
    name: 'United Kingdom of Great Britain and Northern Ireland',
  },
  {
    key: 'UM',
    name: 'United States Minor Outlying Islands',
  },
  {
    key: 'US',
    name: 'United States of America',
  },
  {
    key: 'UY',
    name: 'Uruguay',
  },
  {
    key: 'UZ',
    name: 'Uzbekistan',
  },
  {
    isEu: true,
    key: 'VU',
    name: 'Vanuatu',
  },
  {
    key: 'VE',
    name: 'Venezuela, Bolivarian Republic of',
  },
  {
    key: 'VN',
    name: 'Viet Nam',
  },
  {
    key: 'VG',
    name: 'Virgin Islands, British',
  },
  {
    key: 'VI',
    name: 'Virgin Islands, U.S.',
  },
  {
    key: 'WF',
    name: 'Wallis and Futuna',
  },
  {
    key: 'EH',
    name: 'Western Sahara',
  },
  {
    key: 'YE',
    name: 'Yemen',
  },
  {
    key: 'ZM',
    name: 'Zambia',
  },
  {
    key: 'ZW',
    name: 'Zimbabwe',
  },
  {
    key: 'AX',
    name: 'Åland Islands',
  },
];

const bannedCountries = [
  {
    key: 'BY',
    name: 'Belarus',
  },
  {
    key: 'CU',
    name: 'Cuba',
  },
  {
    key: 'IR',
    name: 'Iran, Islamic Republic of',
  },
  {
    key: 'KP',
    name: "Korea, Democratic People's Republic of",
  },
  {
    key: 'RU',
    name: 'Russian Federation',
  },
  {
    key: 'SY',
    name: 'Syrian Arab Republic',
  },
];

const getFilteredCountries = differenceBy(allCountries, bannedCountries, 'key');

export default getFilteredCountries;
